import { sva } from "@agapi/ui/panda/css";

export const navbarSearchStyles = sva({
  slots: ['stickyContainer', 'closeButton', 'suggestionsContainer', 'productsContainer', 'blogResultsContainer', 'categoryResultsContainer', 'brandResultsContainer', 'fixedButton', 'spacer'],
  base: {
    stickyContainer: {
      position: 'sticky',
      top: 3,
      pt: '0',
      display: 'flex',
      width: '100%',
      justifyContent: 'flex-end',
      height: '0px',
      overflow: 'visible',
      zIndex: '9',
      _hover: {
        scale: 1
      },
      _active: {
        scale: 1
      },
      sm: {
        pt: '5',
        top: '4',
        right: '4'
      }
    },
    closeButton: {
      position: 'absolute',
      top: 0,
      borderRadius: '100%',
      backgroundColor: 'white/70',
      backdropFilter: 'blur(4px)',
    },
    suggestionsContainer: {
      gridArea: 'suggestions',
    },
    productsContainer: {
      gridArea: 'products',
      pb: '7',
      _first: {
        pt: '0',
      }
    },
    blogResultsContainer: {
      pt: '3',
      gridArea: 'blog',
      _first: {
        pt: '0',
      }
    },
    categoryResultsContainer: {
      pt: '3',
      gridArea: 'categories',
      _first: {
        pt: '0',
      }
    },
    brandResultsContainer: {
      pt: '3',
      gridArea: 'brands',
      _first: {
        pt: '0',
      }
    },
    spacer: {
      gridArea: 'spacer',
      minHeight: '44px',
    },
    fixedButton: {
      display: 'flex',
      position: 'fixed',
      width: '100%',
      bottom: 0,
      left: 0,
      sm: {
        mt: '6',
        justifyContent: 'center',
        position: 'unset',
        width: 'unset',
        bottom: 'unset',
        left: 'unset'
      }
    }
  }
});

